import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home/Home.vue';
import BinaryTree from '../views/BinaryTree/BinaryTree.vue';
import BinaryTree2 from '../views/BinaryTree2/BinaryTree2.vue';
import BinaryTree3 from '../views/BinaryTree3/BinaryTree3.vue';
import BinaryTree4 from '../views/BinaryTree4/BinaryTree4.vue';
import RadialDendrogram from '../views/RadialDendrogram/RadialDendrogram.vue';
import D3RadialDendrogram from '../views/D3RadialDendrogram/D3RadialDendrogram.vue';
import AnimationTest from '../views/AnimationTest/AnimationTest.vue';
import D3AnimationTest from '../views/D3AnimationTest/D3AnimationTest.vue';
import ObservableMigration from '../views/ObservableMigration/ObservableMigration.vue';
import ImageList from '../views/ImageList/ImageList.vue';
import MultipleColorPalettes from '../views/MultipleColorPalettes/MultipleColorPalettes.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'image-list',
    component: ImageList
  },
  {
    path: '/test',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/binary-tree',
    name: 'binary-tree',
    component: BinaryTree
  },
  {
    path: '/binary-tree2',
    name: 'binary-tree2',
    component: BinaryTree2
  },
  {
    path: '/binary-tree3',
    name: 'binary-tree3',
    component: BinaryTree3
  },
  {
    path: '/binary-tree4',
    name: 'binary-tree4',
    component: BinaryTree4
  },
  {
    path: '/radial-dendrogram-basiccode',
    name: 'radial-dendrogram-basiccode',
    component: RadialDendrogram
  },
  {
    path: '/radial-dendrogram',
    name: 'radial-dendrogram',
    component: D3RadialDendrogram
  },
  {
    path: '/animation-test',
    name: 'animation-test',
    component: AnimationTest
  },
  {
    path: '/d3animation-test',
    name: 'd3animation-test',
    component: D3AnimationTest
  },
  {
    path: '/observable-migration',
    name: 'observable-migration',
    component: ObservableMigration
  },
  {
    path: '/multiple-color-palettes',
    name: 'multiple-color-palettes',
    component: MultipleColorPalettes
  }

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
